module.exports = __webpack_public_path__ + "img/DE01111.ce220fb7.svg";